"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Backdrop_1 = __importDefault(require("@material-ui/core/Backdrop"));
var Backdrop = function (props) {
    var children = props.children, classes = props.classes, invisible = props.invisible, open = props.open, transitionDuration = props.transitionDuration;
    return (react_1.default.createElement(Backdrop_1.default, { classes: classes, invisible: invisible, open: open, transitionDuration: transitionDuration }, children));
};
exports.default = Backdrop;
